var SHOP_ROOT = '/shop';
var SHOP_PREFIX = "".concat(SHOP_ROOT, "/");
var SEARCH_QUERY_PARAM = 'query';
export function buildShopHref(_a) {
    var _b = _a === void 0 ? {} : _a, topic = _b.topic, product = _b.product;
    if (topic && product)
        return "".concat(SHOP_ROOT, "/").concat(topic, "+").concat(product);
    if (topic)
        return "".concat(SHOP_ROOT, "/").concat(topic);
    if (product) {
        return "".concat(SHOP_ROOT, "?").concat(SEARCH_QUERY_PARAM, "=").concat(encodeURIComponent(product));
    }
    return "".concat(SHOP_ROOT, "/");
}
export function parseActiveSelection(location) {
    var _a, _b;
    var pathname = (_b = (_a = URL.parse(location, 'http://n')) === null || _a === void 0 ? void 0 : _a.pathname) !== null && _b !== void 0 ? _b : '';
    if (!pathname.startsWith(SHOP_PREFIX)) {
        return { topic: null, product: null };
    }
    var _c = pathname
        .slice(SHOP_PREFIX.length)
        .split('/')[0]
        .split('+'), topic = _c[0], product = _c[1];
    return { topic: topic || null, product: product || null };
}
